export function setTitle(title) {
  const suffix = "Biggest Fan |";
  document.title = `${suffix} ${title}`;
}